export default {
  pagesGameClassify: {
    sureDeleteClassify: '确定要删除游戏分类吗',
    sureDeleteGameClassify: '确定要删除所选游戏分类吗',
    sureDeleteClassifyStatus: '确定要修改游戏分类状态吗',
    selectDeleteOption: '请选择要删除的选项',
    name: '游戏分类名称',
    status: '状态',
    name1: '排序',
    name2: '操作',
    errorClassifyName: '请填写游戏分类名称',
    errorPlaceholderSort: '请填写排序'
  },
  pagesGameManage: {
    sureUseGame: '确定启用该游戏',
    sureNotUserGame: '确定禁用该游戏',
    game: '游戏',
    platform: '所属平台',
    gameIcon: '游戏图标',
    gameClassify: '游戏分类',
    gameName: '游戏名称',
    gameCode: '游戏代码',
    pumping: '奖金抽水',
    back: '返点',
    maxBack: '最大返点',
    minBack: '最小返点',
    error1: '请选择游戏分类',
    error2: '请填写游戏名称',
    error3: '请填写游戏代码',
    error4: '请填写奖金抽水',
    error5: '奖金抽水必须大于等于0',
    error6: '请填写最小返点',
    error7: '最小返点必须大于等于0',
    error8: '最小返点不能超过最大返点',
    error9: '请填写最大返点',
    error10: '最大返点必须大于等于0',
    error11: '最大返点不能小于最小返点',
    error12: '请填写排序',
    error13: '请上传游戏图标',
    error14: '请填写初始奖池金额',
    error15: '请填写正整数',
    error16: '请填写入奖百分比',
    error17: '请填写0-100，最多两位小数',
    error18: '请填写活动抽水',
    error19: '请选择平台',
    error20: '请选择游戏',
    error21: '请选择用户',
    title1: '奖池配置',
    title2: '游戏名称',
    title3: '初始奖池金额',
    title4: '投注金额',
    title5: '初始奖池金额(Gold)',
    title6: '入奖百分比',
    title7: '初始奖池金额(Silver)',
    title8: '活动抽水',
    title9: '返点设置',
    title10: 'RTP设置',
    title11: '真实RTP',
    title12: '普通玩法RTP',
    title13: '特殊玩法RTP',
    remark: '系统向奖池放入游戏每期盈利金额的百分比',
    quick: '快捷用语',
    placeholderGame: '请选择游戏',
    placeholderAddMember: '添加用户',
    placeholderRemark: '备注'
  },
  pagesGameFishManage: {
    title1: '图标',
    title2: '鱼类',
    title3: '最小赔率',
    title4: '最大赔率',
    title5: '最小击杀概率',
    title6: '最大击杀概率',
    title7: '生存周期',
    title8: '是否特殊鱼',
    title9: '路径最小间隔',
    title10: '默认赔率',
    title11: '最小赔率',
    title12: '最大赔率',
    title13: '默认击杀概率',
    title14: '最小击杀',
    title15: '最大击杀',
    title16: '默认生存周期',
    title17: '默认是否特殊鱼',
    title18: '默认路径最小间隔',
    title19: '图片',
    title20: '鱼类名称',
    statusYes: '是',
    statusNo: '否',
    error1: '请填写鱼类名称',
    error2: '鱼类名称不超过20个字符',
    error3: '请填写最小赔率',
    error4: '最小赔率超过限制',
    error5: '最小赔率为最多两位小数的正数',
    error6: '最小赔率不能超过最大赔率',
    error7: '请填写最大赔率',
    error8: '最大赔率超过限制',
    error9: '最大赔率为最多两位小数的正数',
    error10: '最大赔率不能小于最小赔率',
    error11: '请填写最小击杀',
    error12: '最小击杀为正整数',
    error13: '最小击杀不能超过最大击杀',
    error14: '请填写最大击杀',
    error15: '最大击杀为正整数',
    error16: '最大击杀不能小于最小击杀',
    error17: '请填写生存周期',
    error18: '生存周期为正整数',
    error19: '请填写路径最小间隔',
    error20: '路径最小间隔为正整数',
    error21: '请上传图片',
  },
  gameFishControl: {
    title1: '射击与概率',
    title2: '房间的概率',
    title3: '水位控制',
    title4: '发射区间最小值',
    title5: '发射区间最大值',
    title6: '提升概率',
    title7: '状态',
    title8: '房间类型',
    title9: '盈亏/投注比值最小值',
    title10: '盈亏/投注比值最大值',
    title11: '发射区间',
    title12: '最小值',
    title13: '最大值',
    title14: '提升概率',
    title15: '盈亏/投注比值',
    operate: '操作',
    placeholderProbability: '请输入提升概率',
  },
  pagesGameRobotData: {
    title1: '盈亏总金额',
    title2: '所属平台',
    title3: '统计时间',
    title4: '游戏',
    title5: '投注金额',
    title6: '盈亏金额',
    title7: '操作',
    title8: '详情',
    title9: '搜索',
    title10: '机器人ID',
    title11: '时间',
    title12: '投注',
    title13: '机器人数量',
    title14: '机器人名称',
    title15: '参与次数',
    title16: '投注次数（订单数）',
    title17: '今天',
    title18: '昨天',
    title19: '近7天',
    title20: '近30天',
    title21: '近90天',
  },
  pagesGameOdds: {
    name1: '游戏分类',
    name2: '游戏名称',
    name3: '玩法',
    name4: '默认赔率',
    name5: '操作',
    name6: '游戏',
    name7: '当期投注最大金额'
  },
  pagesGameBlack: {
    name1: '游戏名称',
    name2: '账号',
    name3: '所属平台',
    name4: '备注',
    name5: '创建',
    name6: '操作',
    name7: '游戏',
    message1: '请选择要取消黑名单的选项',
    message2: '黑名单添加成功',
    message3: '确定要取消黑名单吗'
  },
  gameJackPotDatas: {
    gameName: "游戏",
    activityName: "活动",
    initPrizePoolAmount: "当前奖池初始金额",
    botAddAmount: "机器人入奖金额",
    userAddAmount: "用户入奖金额",
    totalAmount: "当前奖池金额",
    option: "操作",
    platformCode: "所属平台",
    issue: "期号",
    botBetAmount: "机器人投注金额",
    botPrizePoolAmount: "奖池金额--机器人",
    userBetAmount: "用户投注金额",
    userPrizePoolAmount: "奖池金额--用户",
    prizePoolAddAmount: "奖池金额--增加金额",
    totalPrizePoolAmount: "奖池金额--总金额",
    bombIssue: "爆炸期号",
    prizeNum: "开奖号码",
    prizePoolAmount: "奖池金额",
    initPrizePoolAmount1: "奖池金额--初始",
    userPrizeCount: "用户中奖数",
    userPrizeTotal: "用户中奖总金额",
    userPrizeInfo: "用户中奖详情",
    prizePoolAmountInfo: "奖池金额记录",
    account: "用户账号",
    betAmount: "获奖投注金额",
    prizeAmount: "获奖金额",
    activityPumping: "活动抽水",
    filterBot: "过滤机器人",
    botFlag: "机器人",
    botFlag0: "是",
    botFlag1: "否",
    historyTitle: "历史记录"
  }
}
